import React from 'react';
import { Box, alpha } from '@mui/material';
import { Add as AddIcon, Check as CheckIcon } from '@mui/icons-material';

// One day in the grid: a filled shift block when they work it, an empty
// slot when they do not, so a row reads as the shape of someone's week. The
// plus only appears on hover, as the way to add a day. A real toggle
// button, so a schedule can be filled in from the keyboard too.
const DayCell: React.FC<{
  on: boolean;
  label: string;
  disabled?: boolean;
  onToggle: () => void;
}> = ({ on, label, disabled, onToggle }) => (
  <Box
    component="button"
    type="button"
    aria-pressed={on}
    aria-label={label}
    disabled={disabled}
    onClick={onToggle}
    sx={{
      display: 'grid', placeItems: 'center',
      width: '100%', height: 28, p: 0, border: 0, borderRadius: 1.5,
      cursor: disabled ? 'default' : 'pointer',
      bgcolor: (t) => (on ? alpha(t.palette.primary.main, 0.22) : 'transparent'),
      color: 'primary.main',
      '& .add': { display: 'none', color: 'text.disabled' },
      '&:hover:not(:disabled)': {
        bgcolor: (t) => (on ? alpha(t.palette.primary.main, 0.34) : t.palette.action.hover),
        '& .add': { display: 'block' },
      },
      '&:focus-visible': { outline: '2px solid', outlineColor: 'primary.main' },
    }}
  >
    {on ? <CheckIcon sx={{ fontSize: 17 }} /> : <AddIcon className="add" sx={{ fontSize: 16 }} />}
  </Box>
);

export default DayCell;
